import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { momentInstance } from 'helpers/date-time';
import { cn } from 'helpers/css';
import { PlusCircle } from 'lucide-react';
import NewDesign from 'components/NewDesign';
import { Badge } from 'shadcn/components/badge';
import { Popover, PopoverContent, PopoverTrigger } from 'shadcn/components/popover';
import TimePicker from 'components/TimePicker';

const Select24HoursAndMinutes = ({ className, date, onChange, disabled }) => {
  const [open, setOpen] = useState(false);
  const hasValidDate = date && momentInstance(date).isValid();
  const initialMoment = hasValidDate ? momentInstance(date) : momentInstance().startOf('date');
  const normalizedInitialMoment = initialMoment.clone().set('second', 0);

  return (
    <div className={cn('component:Select24HoursAndMinutes', className)}>
      <Formik
        enableReinitialize
        initialValues={{
          date: normalizedInitialMoment,
        }}
        onSubmit={(values) => {
          onChange(values.date);
        }}
      >
        {({ values, handleSubmit, setFieldValue }) => {
          const hour = hasValidDate ? values?.date.format('HH') : '--';
          const minute = hasValidDate ? values?.date.format('mm') : '--';

          return (
            <Form>
              <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild disabled={disabled}>
                  <div
                    className={cn(
                      'tw-border tw-rounded-md tw-border-dashed !tw-min-h-9 tw-h-auto tw-py-[6px] dark:tw-bg-primary-darkInput tw-flex tw-justify-center tw-items-center tw-gap-1 tw-cursor-pointer',
                      disabled && 'tw-cursor-default'
                    )}
                  >
                    <PlusCircle size={16} />
                    <span className='tw-inline-block tw-ml-1'>Time:</span>
                    <NewDesign.Separator orientation='vertical' className='tw-mx-0.5 tw-h-4' />
                    <Badge variant='secondary' className='tw-rounded-sm tw-px-1 tw-font-extrabold'>
                      {hour}:{minute}
                    </Badge>
                  </div>
                </PopoverTrigger>

                <PopoverContent className='tw-w-auto dark:tw-bg-primary-darkInput'>
                  <TimePicker
                    hour={hour}
                    minute={minute}
                    onClickHour={(hour) => {
                      setFieldValue('date', momentInstance(values.date).set('hours', hour));
                      handleSubmit();
                    }}
                    onClickMinute={(minute) => {
                      setFieldValue('date', momentInstance(values.date).set('minutes', minute));
                      handleSubmit();
                    }}
                  />
                </PopoverContent>
              </Popover>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Select24HoursAndMinutes;
